// src/components/Footer.jsx - UPDATED: Added Event Host Guide to Footer
import { useNavigate, useLocation } from 'react-router-dom';
import { HeartIcon, EnvelopeIcon, IdentificationIcon  } from '@heroicons/react/24/outline';

function Footer({ onNavigate, onBlogNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  // ALL EXISTING FUNCTIONS PRESERVED EXACTLY - NO CHANGES TO EXISTING HANDLERS
  const handleSectionNavigation = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleAboutClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'about_page_click', {
        'event_category': 'navigation',
        'event_label': 'footer_about',
        'click_location': 'footer_quick_links'
      });
    }
  
    if (location.pathname !== '/about') {
      navigate('/about');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      const heroElement = document.getElementById('hero');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const handleLegalPageClick = (page) => {
    navigate(`/${page}`);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // NEW: Community Guidelines handler (existing)
  const handleCommunityGuidelinesClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'community_guidelines_click', {
        'event_category': 'navigation',
        'event_label': 'footer_community_guidelines',
        'click_location': 'footer_legal_section',
        'target_page': 'community_guidelines'
      });
    }

    if (location.pathname !== '/community-guidelines') {
      navigate('/community-guidelines');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // NEW: Event Host Guide handler
  const handleEventHostGuideClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'event_host_guide_click', {
        'event_category': 'navigation',
        'event_label': 'footer_event_host_guide',
        'click_location': 'footer_legal_section',
        'target_page': 'event_host_guide'
      });
    }

    if (location.pathname !== '/event-host-guide') {
      navigate('/event-host-guide');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBlogClick = () => {
    if (location.pathname !== '/blog') {
      navigate('/blog');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleEventsClick = () => {
    if (location.pathname !== '/events') {
      navigate('/events');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubscriptionClick = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'subscription_footer_click', {
      'event_category': 'conversion',
      'event_label': 'footer_subscription',
      'click_location': 'footer_quick_links'
    });
  }

  if (location.pathname !== '/subscription') {
    navigate('/subscription');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

  const handleMonthlyFikaClick = () => {
    if (location.pathname !== '/monthly-fika') {
      navigate('/monthly-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSignatureFikaClick = () => {
    if (location.pathname !== '/signature-fika') {
      navigate('/signature-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleWhatIsFikaClick = () => {
    if (location.pathname !== '/what-is-fika') {
      navigate('/what-is-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // NEW: What is Curated Fika handler (following Header pattern)
  const handleWhatIsCuratedFikaClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'what_is_curated_fika_click', {
        'event_category': 'navigation',
        'event_label': 'footer_what_is_curated_fika',
        'click_location': 'footer_fika_section'
      });
    }
  
    if (location.pathname !== '/curated-fika') {
      navigate('/curated-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleWhatIsSpeedFikaClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'what_is_speed_fika_click', {
        'event_category': 'navigation',
        'event_label': 'footer_what_is_speed_fika',
        'click_location': 'footer_fika_section',
        'target_page': 'what_is_speed_fika'
      });
    }
  
    if (location.pathname !== '/what-is-speed-fika') {
      navigate('/what-is-speed-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  const handleFikaPracticeClick = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'fika_practice_click', {
      'event_category': 'navigation',
      'event_label': 'footer_fika_practice',
      'click_location': 'footer_quick_links'
    });
  }

  if (location.pathname !== '/fika-practice/today') {
    navigate('/fika-practice/today');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

  // NEW: Curated Fika handler (following Header pattern)
  const handleCuratedFikaClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'curated_fika_click', {
        'event_category': 'navigation',
        'event_label': 'footer_curated_fika',
        'click_location': 'footer_fika_section',
        'target_service': 'curated_fika_premium'
      });
    }

    if (location.pathname !== '/curated-fika-signup') {
      navigate('/curated-fika-signup');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleMySessionsClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'my_sessions_click', {
        'event_category': 'navigation',
        'event_label': 'footer_my_sessions',
        'click_location': 'footer_fika_section',
        'target_page': 'curated_fika_my_sessions'
      });
    }
  
    if (location.pathname !== '/curated-fika/my-sessions') {
      navigate('/curated-fika/my-sessions');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // EXISTING HANDLERS - Now moved to Resources section
  const handleMemberPassportClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'member_passport_click', {
        'event_category': 'navigation',
        'event_label': 'footer_member_passport',
        'click_location': 'footer_resources_section',
        'target_page': 'member_passport'
      });
    }
  
    if (location.pathname !== '/member-passport') {
      navigate('/member-passport');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // NEW: Founders 1-on-1 Conversation Starters handler
  const handleFounderConversationsClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'founder_conversations_click', {
        'event_category': 'navigation',
        'event_label': 'footer_founder_conversations',
        'click_location': 'footer_resources_section',
        'target_service': 'founder_conversation_starters'
      });
    }
  
    if (location.pathname !== '/founder-conversations') {
      navigate('/founder-conversations');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // NEW: Tokyo Cafe Guide handler
  const handleCafeGuideClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'cafe_guide_click', {
        'event_category': 'navigation',
        'event_label': 'footer_tokyo_cafe_guide',
        'click_location': 'footer_resources_section',
        'target_page': 'coffee_guide_tokyo',
        'target_city': 'tokyo'
      });
    }
  
    if (location.pathname !== '/coffee-guide/tokyo') {
      navigate('/coffee-guide/tokyo');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // NEW: Event Photos handler
  const handlePhotosClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'photos_page_click', {
        'event_category': 'navigation',
        'event_label': 'footer_photos',
        'click_location': 'footer_resources_section',
        'target_page': 'event_photos'
      });
    }
  
    if (location.pathname !== '/photos') {
      navigate('/photos');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleConversationStartersClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversation_starters_click', {
        'event_category': 'navigation',
        'event_label': 'footer_conversation_starters',
        'click_location': 'footer_resources_section',
        'target_service': 'conversation_tools'
      });
    }

    if (location.pathname !== '/conversation-starters') {
      navigate('/conversation-starters');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleHappinessClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'happiness_page_click', {
        'event_category': 'navigation',
        'event_label': 'footer_happiness',
        'click_location': 'footer_resources_section',
        'target_page': 'happiness_wellbeing'
      });
    }
  
    if (location.pathname !== '/happiness') {
      navigate('/happiness');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleWhyConnectCoClick = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'why_connectco_click', {
      'event_category': 'navigation',
      'event_label': 'footer_why_connectco',
      'click_location': 'footer_quick_links'
    });
  }

  if (location.pathname !== '/why-connectco') {
    navigate('/why-connectco');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const handlePartnerClick = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'partner_page_click', {
      'event_category': 'navigation',
      'event_label': 'footer_partner',
      'click_location': 'footer_quick_links'
    });
  }
  if (location.pathname !== '/partner-with-us') {
    navigate('/partner-with-us');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

  const handleTokyoExpatGuideClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'tokyo_expat_guide_click', {
        'event_category': 'navigation',
        'event_label': 'footer_tokyo_expat_guide',
        'click_location': 'footer_resources_section',
        'target_audience': 'new_expats'
      });
    }

    if (location.pathname !== '/tokyo-expat-guide') {
      navigate('/tokyo-expat-guide');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleTokyoExpatCalculatorClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'tokyo_expat_calculator_click', {
        'event_category': 'navigation',
        'event_label': 'footer_tokyo_expat_calculator',
        'click_location': 'footer_resources_section',
        'target_tool': 'expat_calculator',
        'target_audience': 'tokyo_expats'
      });
    }

    if (location.pathname !== '/tokyo-expat-calculator') {
      navigate('/tokyo-expat-calculator');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNomadConciergClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'nomad_concierge_click', {
        'event_category': 'navigation',
        'event_label': 'footer_nomad_concierge',
        'click_location': 'footer_resources_section'
      });
    }
  
    if (location.pathname !== '/nomad-concierge') {
      navigate('/nomad-concierge');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBuildersCoffeeMatchClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'builders_coffee_match_click', {
        'event_category': 'navigation',
        'event_label': 'footer_builders_coffee_match',
        'click_location': 'footer_fika_section',
        'target_service': 'founders_1on1_matching'
      });
    }
  
    if (location.pathname !== '/curated-fika/founders') {
      navigate('/curated-fika/founders');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleDeepFikaClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'deep_fika_click', {
        'event_category': 'navigation',
        'event_label': 'footer_deep_fika',
        'click_location': 'footer_fika_section',
        'target_page': '/deep-fika'
      });
    }
    if (location.pathname !== '/deep-fika') {
      navigate('/deep-fika');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleGoalAccountabilityPartnersClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'goal_accountability_partners_click', {
        'event_category': 'navigation',
        'event_label': 'footer_goal_accountability_partners',
        'click_location': 'footer_fika_section',
        'target_service': 'goal_accountability_matching'
      });
    }
  
    if (location.pathname !== '/goal-accountability-partners') {
      navigate('/goal-accountability-partners');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleGoalAccountabilityFAQClick = () => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'goal_accountability_faq_click', {
        'event_category': 'navigation',
        'event_label': 'footer_goal_accountability_faq',
        'click_location': 'footer_fika_section',
        'target_service': 'goal_accountability_support'
      });
    }
  
    if (location.pathname !== '/goal-accountability-faq') {
      navigate('/goal-accountability-faq');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleMeetupClick = (locationName, url) => {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'meetup_group_click', {
        'event_category': 'external_link',
        'event_label': locationName,
        'meetup_group': locationName,
        'click_location': 'footer'
      });
    }
    
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Company Info - PRESERVED EXACTLY */}
          <div className="md:col-span-2">
            <button 
              onClick={handleLogoClick}
              className="text-2xl font-bold mb-2 hover:text-gray-300 transition-colors cursor-pointer text-left"
            >
              <div className="flex items-center">
              {/* Nested C SVG Logo Mark */}
              <svg width="30" height="32" viewBox="0 0 30 32" className="flex-shrink-0 group-hover:scale-105 transition-transform duration-200">
                <defs>
                  <linearGradient id="innerCGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{ stopColor: '#FBBF24' }} />
                    <stop offset="100%" style={{ stopColor: '#F97316' }} />
                  </linearGradient>
                </defs>
                
                {/* Outer C - Purple (open on the right) */}
                <path
                  d="M 24 10 A 10 10 0 1 0 24 22"
                  fill="none"
                  stroke="#9333EA"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                
                {/* Inner C - Orange Gradient (open on the right) */}
                <path
                  d="M 21 12 A 7 7 0 1 0 21 20"
                  fill="none"
                  stroke="url(#innerCGradient)"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
              
              {/* Rest of the text */}
              <span className="text-2xl font-bold text-purple-600">
                onnectCo
              </span>

              

            </div>
            
            {/*
            <span className="text-xs font-medium text-amber-600 tracking-wide -mt-0.5">
              Where Strangers Become Friends
            </span>
            */}

            <span className="text-[11px] sm:text-sm text-amber-600 whitespace-nowrap -mt-0.5">
              No strangers. Just remarkable people.
            </span>

          </button>
            
            {/* Building the infrastructure for meaningful human connection. Connect & Co is a community-building hub that helps individuals forge authentic friendships through curated Swedish Fika experiences. */}
            <p className="text-gray-300 mb-4 max-w-md leading-relaxed">
               ConnectCo is on a mission to make you remarkable — one real conversation at a time. We bring locals, expats, and digital nomads together through the Swedish tradition of fika: intentional, unhurried gatherings where no one is networking and everyone is present. Remarkable people make each other more remarkable. That's the whole idea.  
            </p>
            <p className="text-gray-300 text-sm mb-6">
              Currently active in Tokyo • Expanding to other cities
            </p>
            <div className="flex items-center text-gray-400">
              <span>Made with</span>
              <HeartIcon className="w-4 h-4 mx-1 text-red-500" />
              <span>for remarkable people everywhere</span>
            </div>
          </div>

          {/* REORGANIZED: Quick Links with Resources section */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Quick Links</h2>
            <ul className="space-y-2 text-gray-300">
              {/* NEW: Membership - Most Prominent Position */}
               
              <li>
                <button 
                  onClick={handleSubscriptionClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left font-semibold"
                >
                  <span className="mr-2">⭐</span>
                  <div>
                    <span className="flex items-center">
                      Membership
                      <span className="ml-2 px-2 py-0.5 bg-gradient-to-r from-orange-600 to-amber-600 text-white text-xs rounded-full font-medium">
                        PLANS
                      </span>
                    </span>
                    <span className="text-xs text-gray-300 block">View Plans & Pricing</span>
                  </div>
                </button>
              </li>
              


              <li>
                <button 
                  onClick={handleEventsClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">✨</span>
                  <div>
                    <span>Experiences</span>
                    <span className="text-xs text-gray-300 block">View upcoming events</span>
                  </div>
                </button>
              </li>

              <li>
                <button
                  onClick={handleFikaPracticeClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">🔥</span>
                  <div>
                    <span className="flex items-center">
                      Daily Fika Practice
                      <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-amber-600 to-orange-600 text-amber-100 text-xs rounded-full font-medium">
                        DAILY
                      </span>
                    </span>
                    <span className="text-xs text-gray-300 block">2-min daily connection habit</span>
                  </div>
                </button>
              </li>
              
              {/* REORGANIZED: Fika Section - Now includes Curated Fika items */}
              <li className="pt-4 border-t border-gray-700 mt-4">
                <span className="text-sm text-gray-300 block mb-3 font-medium uppercase tracking-wider">
                  Fika
                </span>
                <div className="space-y-2">
                  <button 
                    onClick={handleSignatureFikaClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">⭐</span>
                    <div>
                      <span>Signature Fika</span>
                      <span className="text-xs text-gray-300 block">Weekly Premium</span>
                    </div>
                  </button>
                  
                  <button 
                    onClick={handleMonthlyFikaClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">📅</span>
                    <div>
                      <span>Monthly Fika</span>
                      <span className="text-xs text-gray-300 block">Open to all Subscribers</span>
                    </div>
                  </button>

                  {/* NEW: What is Curated Fika */}

                  <button
                    onClick={handleWhatIsCuratedFikaClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">✨</span>
                    <div>
                      <span>What is Curated Fika?</span>
                      <span className="text-xs text-gray-300 block">Ultra-Premium Experience</span>
                    </div>
                  </button>

                  {/* Deep Fika — 1-on-1 */}
                  <button
                    onClick={handleDeepFikaClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🫂</span>
                    <div>
                      <span className="flex items-center gap-1.5">
                        Deep Fika
                        <span className="px-1.5 py-0.5 bg-emerald-700 text-emerald-200 text-xs rounded-full font-medium">
                          1-on-1
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">One Matched Conversation</span>
                    </div>
                  </button>

                  {/* NEW: Curated Fika Signup */}
                   {/* 
                  onClick={handleCuratedFikaClick}
                  */}
                  <button 
                      onClick={handleCuratedFikaClick}   
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">💫</span>
                    <div>
                      <span className="flex items-center">
                        Curated Fika
                        {/*
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-purple-600 to-amber-600 text-purple-100 text-xs rounded-full font-medium">
                          BETA
                        </span>
                        */}
                      </span>
                      <span className="text-xs text-gray-300 block">Reserve Your Spot</span>
                    </div>
                  </button>

                   {/* NEW: Builders Coffee Match - Founders 1-on-1 */}
                  <button 
                    onClick={handleBuildersCoffeeMatchClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">☕</span>
                    <div>
                      <span className="flex items-center">
                        Builders Coffee Match
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-orange-600 to-red-600 text-orange-100 text-xs rounded-full font-medium">
                          1-on-1
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Founders & Entrepreneurs</span>
                    </div>
                  </button>

                  

                  {/* NEW: My Sessions - Manage Curated Fika bookings */}
                    <button 
                      onClick={handleMySessionsClick}
                      className="hover:text-white transition-colors flex items-center w-full text-left"
                    >
                      <span className="mr-2">📋</span>
                      <div>
                        <span>My Curated Sessions</span>
                        <span className="text-xs text-gray-300 block">View & Manage</span>
                      </div>
                    </button>

                  

                  <button 
                    onClick={handleWhatIsFikaClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🇸🇪</span>
                    <div>
                      <span>What is Fika?</span>
                      <span className="text-xs text-gray-300 block">Swedish Tradition</span>
                    </div>
                  </button>

                  <button 
                      onClick={handleWhatIsSpeedFikaClick}
                      className="hover:text-white transition-colors flex items-center w-full text-left"
                    >
                      <span className="mr-2">⚡</span>
                      <div>
                        <span>What is Speed Fika?</span>
                        <span className="text-xs text-gray-300 block">Psychology-Based Connection</span>
                      </div>
                  </button>
                  
                   {/*
                  <button 
                    onClick={handleGoalAccountabilityPartnersClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🎯</span>
                    <div>
                      <span className="flex items-center">
                        Goal Accountability Partners
                        <span className="ml-2 px-1.5 py-0.5 bg-blue-600 text-blue-100 text-xs rounded-full font-medium">
                          FREE
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Find Your Tribe</span>
                    </div>
                  </button>

                  <button 
                    onClick={handleGoalAccountabilityFAQClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left ml-6"
                  >
                    <span className="mr-2">❓</span>
                    <div>
                      <span>FAQ & Questions</span>
                      <span className="text-xs text-gray-300 block">Get Answers</span>
                    </div>
                  </button>
                  */}

                </div>
              </li>

              {/* NEW: Resources Section - UPDATED with Founders 1-on-1 & Photos */}
              <li className="pt-4 border-t border-gray-700 mt-4">
                <span className="text-sm text-gray-300 block mb-3 font-medium uppercase tracking-wider">
                  Resources
                </span>
                <div className="space-y-2">
                  <button 
                    onClick={handleMemberPassportClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🎫</span>
                    <div>
                      <span className="flex items-center">
                        Member Passport
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-purple-600 to-blue-600 text-purple-100 text-xs rounded-full font-medium">
                          TRACK
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Your Event Journey & Upcoming Events</span>
                    </div>
                  </button>

                

                  {/* NEW: Event Photos */}
                  <button 
                    onClick={handlePhotosClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">📸</span>
                    <div>
                      <span>Event Photos</span>
                      <span className="text-xs text-gray-300 block">Community Memories</span>
                    </div>
                  </button>

                  {/* NEW: Tokyo Cafe Guide */}
                  <button 
                    onClick={handleCafeGuideClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">☕</span>
                    <div>
                      <span className="flex items-center">
                        Global Cafe Guide
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-amber-600 to-yellow-600 text-amber-100 text-xs rounded-full font-medium">
                          GUIDE
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Best Coffee Spots</span>
                    </div>
                  </button>

                    {/* NEW: Founders 1-on-1 Conversation Starters */}
                  <button 
                    onClick={handleFounderConversationsClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">👔</span>
                    <div>
                      <span className="flex items-center">
                        Founders 1-on-1
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-amber-600 to-orange-600 text-amber-100 text-xs rounded-full font-medium">
                          DEEP
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Conversation Starters</span>
                    </div>
                  </button>

                  <button 
                    onClick={handleConversationStartersClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">💬</span>
                    <div>
                      <span>Conversation Starters & Wellness</span>
                      <span className="text-xs text-gray-300 block">300+ Questions</span>
                    </div>
                  </button>

                  

                  <button 
                    onClick={handleHappinessClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">😊</span>
                    <div>
                      <span>How to Be Happy</span>
                      <span className="text-xs text-gray-300 block">Friendship & Connection</span>
                    </div>
                  </button>

                  <button 
                      onClick={handleNomadConciergClick}
                      className="hover:text-white transition-colors flex items-center w-full text-left"
                    >
                      <span className="mr-2">🌍</span>
                      <div>
                        <span>Nomad Concierge</span>
                        <span className="text-xs text-gray-300 block">Live like a local</span>
                      </div>
                    </button>

                  <button 
                    onClick={handleTokyoExpatGuideClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🗾</span>
                    <div>
                      <span className="flex items-center">
                        Tokyo Expat Guide
                        <span className="ml-2 px-1.5 py-0.5 bg-green-600 text-green-100 text-xs rounded-full font-medium">
                          NEW
                        </span>
                      </span>
                      <span className="text-xs text-gray-300 block">Essential Guide</span>
                    </div>
                  </button>

                  <button 
                    onClick={handleTokyoExpatCalculatorClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🧮</span>
                    <div>
                      <span className="flex items-center">
                        Tokyo Expat Calculator
                        {/*
                        <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-blue-600 to-purple-600 text-blue-100 text-xs rounded-full font-medium">
                          🔥 BETA
                        </span>
                        */}
                      </span>
                      <span className="text-xs text-gray-300 block">Save Time, Money & Loneliness</span>
                    </div>
                  </button>

                  <button 
                    onClick={handleGoalAccountabilityPartnersClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🎯</span>
                    <div>
                      <span className="flex items-center">
                        Goal Accountability Partners
                        {/*
                        <span className="ml-2 px-1.5 py-0.5 bg-blue-600 text-blue-100 text-xs rounded-full font-medium">
                          FREE
                        </span>
                        */}
                      </span>
                      <span className="text-xs text-gray-300 block">Find Your Tribe</span>
                    </div>
                  </button>

                  <button 
                    onClick={handleGoalAccountabilityFAQClick}
                    className="hover:text-white transition-colors flex items-center w-full text-left ml-6"
                  >
                    <span className="mr-2">❓</span>
                    <div>
                      <span>FAQ & Questions</span>
                      <span className="text-xs text-gray-300 block">Get Answers</span>
                    </div>
                  </button>



                </div>
              </li>

              {/* EXISTING sections preserved */}
               {/* 
              <li>
                <button 
                  onClick={() => {
                    navigate('/experiences');
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }, 100);
                  }}
                  className="hover:text-white transition-colors"
                >
                  Experiences
                </button>
              </li>
              */}

             <li>
              <button 
                onClick={handleBlogClick}
                className="hover:text-white transition-colors flex items-center w-full text-left"
              >
                <span className="mr-2">📖</span>
                <div>
                  <span>Stories</span>
                  <span className="text-xs text-gray-300 block">Read our blog</span>
                </div>
              </button>
            </li>

             <li>
                <button 
                  onClick={() => handleSectionNavigation('interactive')}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">🤝</span>
                  <div>
                    <span>Community</span>
                    <span className="text-xs text-gray-300 block">Join the conversation</span>
                  </div>
                </button>
              </li>

              <li>
                <button 
                  onClick={handleAboutClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">ℹ️</span>
                  <div>
                    <span>About</span>
                    <span className="text-xs text-gray-300 block">Our story & mission</span>
                  </div>
                </button>
              </li>

              <li>
                <button
                  onClick={handlePartnerClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">🤝</span>
                  <div>
                    <span className="flex items-center">
                      Partner with ConnectCo
                      <span className="ml-2 px-1.5 py-0.5 bg-gradient-to-r from-emerald-700 to-teal-700 text-emerald-100 text-xs rounded-full font-medium">
                        BRANDS
                      </span>
                    </span>
                    <span className="text-xs text-gray-300 block">Sponsorships & partnerships</span>
                  </div>
                </button>
              </li>

              <li>
                <button 
                  onClick={handleWhyConnectCoClick}
                  className="hover:text-white transition-colors flex items-center w-full text-left"
                >
                  <span className="mr-2">🧭</span>
                  <div>
                    <span>Why ConnectCo</span>
                    <span className="text-xs text-gray-300 block">How we compare & what makes us different</span>
                  </div>
                </button>
              </li>
              
              {/* Meetup Groups Section - PRESERVED EXACTLY */}
              {/*
              <li className="pt-4 border-t border-gray-700 mt-4">
                <span className="text-sm text-gray-300 block mb-3 font-medium uppercase tracking-wider">
                  Join Our Meetup Group
                </span>
                <div className="space-y-2">
                  <button
                    onClick={() => handleMeetupClick('Tokyo', 'https://www.meetup.com/tokyo-connect-co-connection/')}
                    className="hover:text-white transition-colors flex items-center w-full text-left"
                  >
                    <span className="mr-2">🌍</span>
                    <span>International Community Building Hub</span>
                  </button>
                </div>
              </li>
              */}

            </ul>
          </div>

          {/* Contact Section - PRESERVED EXACTLY */}
          <div>
            <h2 className="text-lg font-semibold mb-4">Get in Touch</h2>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center">
                <EnvelopeIcon className="w-4 h-4 mr-2" />
                <span>hello@connectco.app</span>
              </div>
              <div>
                <span>🌍 Available Worldwide</span>
              </div>
              <div className="mt-4">
                <span className="text-sm">Follow us:</span>
                <div className="flex space-x-4 mt-2">
                    {/* 
                  <button className="text-gray-400 hover:text-white transition-colors">
                    📘 Facebook
                  </button>
                   */}
                 
                  <a 
                    href="https://www.instagram.com/connectco.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    📸 Instagram
                  </a>
                    {/* 
                  <button className="text-gray-400 hover:text-white transition-colors">
                    💼 LinkedIn
                  </button>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom - PRESERVED EXACTLY */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} ConnectCo, operated by Pukka Holdings LLC. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center space-x-6 mt-4 md:mt-0">
              <button 
                onClick={() => handleLegalPageClick('privacy')}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => handleLegalPageClick('terms')}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Terms of Service
              </button>
              
              <button 
                onClick={handleCommunityGuidelinesClick}
                className="text-gray-400 hover:text-white text-sm transition-colors font-medium"
              >
                Community Guidelines
              </button>

              {/* NEW: Event Host Guide - Added after Community Guidelines */}
              <button 
                onClick={handleEventHostGuideClick}
                className="text-gray-400 hover:text-white text-sm transition-colors font-medium"
              >
                Event Host Guide
              </button>

              <button
                onClick={handlePartnerClick}
                className="text-gray-400 hover:text-white text-sm transition-colors font-medium"
              >
                Partner with Us
              </button>
              
              <button 
                onClick={() => handleLegalPageClick('cookies')}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Cookies Policy
              </button>
              <button 
                onClick={() => handleLegalPageClick('contact')}
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;